import api from './client';

export const returnsApi = {
  list:           (params?: any) => api.get('/purchase-returns', { params }),
  getGrnItems:    (grnId: number) => api.get(`/purchase-returns/grn/${grnId}`),
  createReturn:   (data: any)    => api.post('/purchase-returns', data),
};
